"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  ATTEMPTED_REFUND_INDIVIDUAL: null,
  ATTEMPTED_REFUND_PACK: null,
  ATTEMPTED_UNINSTALL_INDIVIDUAL: null,
  ATTEMPTED_UNINSTALL_PACK: null,
  SEE_WHERE_IN_USE: null
});

exports.default = _default;
module.exports = exports.default;